import type { IconData } from '@stacksjs/iconify-core'

export const schoolScienceDna: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.145 12.19v3.04H6.855v-3.04h-1.52v7.62h1.52v-3.05h18.29v3.05h1.52v-7.62z\"/><path fill=\"currentColor\" d=\"M6.855 19.81v1.52h1.52v1.52h3.05v-1.52h9.14v1.52h3.05v-1.52h1.53v-1.52zm3.05 9.14v-1.53h-1.53v1.53h-1.52V32h1.52v-1.53h15.24V32h1.53v-3.05h-1.53v-1.53h-1.52v1.53zm9.14-3.05h3.05v1.52h-3.05Zm0-3.05h1.52v1.53h-1.52Zm0-15.24h1.52v1.53h-1.52Zm0-3.04h3.05v1.52h-3.05Zm-6.09 19.81h6.09v1.52h-6.09Zm0-18.29h6.09v1.52h-6.09ZM9.905 25.9h3.05v1.52h-3.05Zm1.52-3.05h1.53v1.53h-1.53Zm0-15.24h1.53v1.53h-1.53Zm-1.52-3.04h3.05v1.52h-3.05Zm12.19-1.53v1.53h1.52V3.04h1.53V0h-1.53v1.52H8.375V0h-1.52v3.04h1.52v1.53h1.53V3.04zm3.05 9.15v-1.53h-1.53V9.14h-3.05v1.52h-9.14V9.14h-3.05v1.52h-1.52v1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default schoolScienceDna
